import type { ActivityStatsResponseDto } from '@lunary/api-client'
import { LineChart } from '../../shared/ui/charts/line-chart'
import { StackedBars } from '../../shared/ui/charts/stacked-bars'
import { formatDate } from '../users/labels'
import { SOURCE_SERIES, indexBy, percent } from './series'
import styles from './overview.module.css'

export function ActivitySection({ data, days }: { data: ActivityStatsResponseDto; days: readonly string[] }) {
  const since = data.tracking_since
  const dau = new Map(data.dau.map((r) => [r.day, r.count]))
  const bySource = indexBy(data.dau_by_source, (r) => r.source, (r) => r.count)
  const present = SOURCE_SERIES.filter((s) => data.dau_by_source.some((r) => r.source === s.key))

  return (
    <section className={styles.section} aria-labelledby="ov-activity">
      <h2 id="ov-activity">Активность</h2>
      {!since && <p className="muted">Учёт визитов по дням включится после деплоя, график начнёт заполняться с первого визита.</p>}
      {since && <p className="muted">Визиты по дням считаются с {formatDate(since)}, раньше данных нет.</p>}
      <div className={styles.split}>
        <div className="card-panel">
          <p className={styles.caption}>Уникальные пользователи за день (DAU)</p>
          <LineChart
            label="DAU по дням"
            days={days}
            value={(d) => (since && d >= since ? (dau.get(d) ?? 0) : null)}
            color="var(--series-1)"
            unit="Пользователей"
          />
        </div>
        <div className="card-panel">
          <p className={styles.caption}>Где заходили (пользователь × источник × день)</p>
          <StackedBars label="Визиты по источникам" days={days} series={present.length > 0 ? present : SOURCE_SERIES.slice(0, 4)} value={bySource} height={200} />
        </div>
      </div>
      <div className="card-panel">
        <p className={styles.caption}>Удержание по неделям регистрации: доля вернувшихся на 1-й, 7-й и 30-й день</p>
        {data.retention.length === 0 ? (
          <p className="muted">Пока нет когорт с данными о визитах.</p>
        ) : (
          <table className="users-table">
            <thead>
              <tr>
                <th>Неделя</th>
                <th>Новых</th>
                <th>D1</th>
                <th>D7</th>
                <th>D30</th>
              </tr>
            </thead>
            <tbody>
              {data.retention.map((c) => (
                <tr key={c.week}>
                  <td>с {formatDate(c.week)}</td>
                  <td>{c.size}</td>
                  {[c.d1, c.d7, c.d30].map((v, i) => (
                    <td key={i}>{v === null ? '—' : percent(v, c.size)}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </section>
  )
}
